import { ReactElement } from 'react'
import { Box, BoxProps } from '@mui/material'
import { MATERIAL_SYMBOL_ICONS, type MaterialSymbolName } from './materialSymbolIcons'

export type MaterialSymbolProps = {
  /** Material Symbols ligature name, e.g. `filter_alt`. */
  icon: MaterialSymbolName | string
  size?: number
  title?: string
  filled?: boolean
  weight?: number
} & Omit<BoxProps, 'children'>

export const MaterialSymbol = ({
  icon,
  size = 18,
  title,
  filled = false,
  sx,
  color,
  ...props
}: MaterialSymbolProps): ReactElement | null => {
  const entry = MATERIAL_SYMBOL_ICONS[icon as MaterialSymbolName]
  if (!entry) {
    return null
  }

  const Icon = filled && 'filled' in entry && entry.filled ? entry.filled : entry.regular

  return (
    <Box
      component="span"
      sx={{
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        lineHeight: 1,
        flexShrink: 0,
        color,
        '& svg': { fill: 'currentColor' },
        ...sx,
      }}
      {...props}
    >
      <Icon width={size} height={size} aria-hidden={title ? undefined : true}>
        {title ? <title>{title}</title> : null}
      </Icon>
    </Box>
  )
}
